import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function SectionLoader() {
  const { t } = useTranslation(['backoffice']);

  return (
    <div className="loader-section" data-testid="loader-section">
      <div className="loader-section__container">
        <Spinner
          className="loader-section__spinner"
          animation="border"
          variant="secondary"
        />
        <span
          className="loader-section__text"
          role="alert"
          aria-busy="true"
          aria-live="polite"
        >
          {t("cargando")}...
        </span>
      </div>
    </div>
  );
}
